import ProfileData from "../interfaces/models/profileData";
import detectBrowserLanguage from "detect-browser-language";
import moment from "moment";

export function createEmptyProfile(username: string, uid: string) {
  const emptyProfile: ProfileData = {} as any;
  emptyProfile.username = username;
  emptyProfile.avatar = {
    skin: 0,
    face: 0,
    other: 0,
    hair: 0,
    gender: "n",
    cloth: 0,
  };
  emptyProfile.os = "web";
  emptyProfile.stars_total = 0;
  emptyProfile.start_date = moment().startOf("day").toISOString();
  emptyProfile.lang = detectBrowserLanguage();
  emptyProfile.$uid = uid;
  emptyProfile.publicProfile = false;
  emptyProfile.supporterMode = true;
  emptyProfile.levels = [];
  emptyProfile.badges = [];
  emptyProfile.stars = [];
  emptyProfile.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone||"Europe/Berlin";
  return emptyProfile;
}



// WEBPACK FOOTER //
// ./src/functions/createProfile.tsx